import React, { useEffect, useState } from "react";
import { Tooltip } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useParams } from "react-router-dom";
import { parserAPI } from "../../utils/parser";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import { alertV2 } from "./../../api";
import {
  printLocation,
  formatDateOnly,
  formatDateTime,
} from "../../utils/helper";
import OtherChart from "./Charts/OtherCharts";
import VibrationChart from "./Charts/VibrationChart";
import { useAuth } from "../../contexts/AuthContext.jsx";
import CloseAlert from "./Modal/CloseAlert";
import MonitorWait from "./Modal/MonitorWait";
import ProceedInspection from "./Modal/ProceedInspection";
import ProceedRepair from "./Modal/ProceedRepair";
import { AlertLog } from "./AlertLog";
import { addHours, format } from "date-fns";
import ImageViewer from "../../components/ImageViewer";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import AlertResult from "./VaFeedback/AlertResult";

function PagesProductDetails() {
  const { username } = useAuth();
  const [loading, setLoading] = useState(true);
  const [alarm, setAlarm] = useState(null);
  const [suspected, setSuspected] = useState([]);
  const [lastAction, setLastAction] = useState("");
  const { config, isHiddenFeature, email } = useAuth();
  const [actionTaken, setActionTaken] = useState("");
  const [dataAction, setDataAction] = useState(null);
  const timezone = config?.timezone;
  const [alertUpdate, setAlertUpdate] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [modalWorkOrder, setModelWorkOrder] = useState(false);
  const [openConfirmDialogue, setOpenConfirmDialogue] = useState(false);
  const [openAlertConfirmationDialog, setOpenAlertConfirmationDialog] =
    useState(false);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const updateLastLog = async (data) => {
    setLastAction(data);
  };

  function convertTz(value) {
    if (!value) return "";
    const timezoneOffset = parseInt(timezone);
    return format(
      addHours(new Date(value), timezoneOffset),
      "yyyy-MM-dd HH:mm:ss"
    );
  }

  const handleUpdateAlert = (update) => {
    setActionTaken(update);
    setDataAction(null);
    setOpenAlertConfirmationDialog(true);
    setAlertUpdate(update);
  };
  const handleClickRespond = async (id) => {
    setDataAction(null);
    setActionTaken(id);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    openAlertConfirmationDialog(false);
  };

  const handleReOpenModal = async () => {
    setOpenConfirmDialogue(true);
  };

  const params = useParams();
  async function fetchAlerts() {
    try {
      setLoading(true);
      const res = await alertV2.getOne(params.alarmId);
      const data = await parserAPI(res);
      data.alert_type = "Vibration"; //need to change later
      setAlarm(data);
      if (data) {
        let suspect = [];
        const suspectall = data?.prediction_values;
        for (const key in suspectall) {
          suspect.push({
            name: key,
            value: suspectall[key],
          });
        }
        const resClass = await alertV2.getAnomalyClassification(params.alarmId);
        const dataClass = await parserAPI(resClass);
        suspect.forEach((item) => {
          const ra = dataClass.find((d) => d.suspected_issue === item.name);
          item.recommended_action = ra ? ra.action : [];
        });
        setSuspected(suspect);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchAlerts();
  }, []);

  const handleReopen = async () => {
    const payload = {
      email: email,
      event_details: `has re-open this Alarm. The Alarm Status has been updated to “Open”.`,
      event_name: "Response",
      event_action: "Re-open",
      alert_id: params.alarmId,
      action_detail: JSON.stringify({
        action_completed: ``,
        action_name: "Re-open",
        confirmed_issue: "",
        action_work: ``,
        additional_comment: "",
      }),
    };

    const res = await alertV2.addLogAction(params.alarmId, payload, null);
    setOpenConfirmDialogue(false);
    onSuccessSubmit();
  };

  const closeAlertConfirmationDialog = () => {
    setOpenAlertConfirmationDialog(false);
  };
  const onSuccessSubmit = async () => {
    setOpenModalSuccess(true);
    fetchAlerts();
    setLoading(true);
    // wait 1 second
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const displayAction = (event, action) => {
    setDataAction(action);

    if (event === "Closed" || event === "Invalid") {
      setAlertUpdate(event);
      setOpenAlertConfirmationDialog(true);
    } else {
      setActionTaken(event);
      setOpenModal(true);
    }
  };

  const openWorkOrder = (data) => {
    setModelWorkOrder(true);
  };
  const closeWorkOrder = () => {
    setModelWorkOrder(false);
  };

  return (
    <div>
      <ConfirmationDlg
        open={modalWorkOrder}
        setOpen={setModelWorkOrder}
        size={"lg"}
        title="Work Order"
        btnSubmitText={"Submit"}
        btnCancelText={"Cancel"}
        onSubmit={closeWorkOrder}
        onClose={closeWorkOrder}
      >
        <img src="/assets/img/ss.png" style={{ width: "100%" }} alt="" />
        <p>
          For More Information Visit Our CMMS System. Click the link
          <a href="https://app.groundup.ai">https://app.groundup.ai</a>
        </p>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">ALARM</a>
            </li>
            <li className="breadcrumb-item active">ALARM DETAILS</li>
          </ol>
          <h1 className="page-header mb-0">Alarm Details</h1>
        </div>
      </div>
      <ConfirmationDlg
        open={openConfirmDialogue}
        setOpen={setOpenConfirmDialogue}
        title="Re-open Alarm"
        btnSubmitText={"Re-open"}
        btnCancelText={"Cancel"}
        onSubmit={handleReopen}
        onClose={() => {
          setOpenConfirmDialogue(false);
        }}
      >
        <h4>Are you sure you want to Re-Open this Alarm?</h4>
      </ConfirmationDlg>
      <CloseAlert
        alertId={params.alarmId}
        suspected={suspected}
        data={dataAction}
        openModal={openAlertConfirmationDialog && alertUpdate === "Closed"}
        setOpenModal={closeAlertConfirmationDialog}
        onSuccess={onSuccessSubmit}
      />
      <MonitorWait
        alertId={params.alarmId}
        actionTaken={actionTaken}
        data={dataAction}
        openModal={openModal && actionTaken === "Monitor and Wait"}
        setOpenModal={setOpenModal}
        onSuccess={onSuccessSubmit}
      />
      <ProceedRepair
        alertId={params.alarmId}
        suspected={suspected}
        openWorkOrder={openWorkOrder}
        data={dataAction}
        actionTaken={actionTaken}
        openModal={openModal && actionTaken === "Proceed with Maintenance"}
        setOpenModal={setOpenModal}
        onSuccess={onSuccessSubmit}
      />
      <ProceedInspection
        alertId={params.alarmId}
        suspected={suspected}
        data={dataAction}
        actionTaken={actionTaken}
        openModal={openModal && actionTaken === "Proceed with Inspection"}
        setOpenModal={setOpenModal}
        onSuccess={onSuccessSubmit}
      />

      <div className="row gx-4">
        <div className="col-lg-8">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Alarm # {alarm?.id}
            </CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div className="me-2">
                        <i className="fa fa-building fa-lg fa-fw text-inverse text-opacity-50"></i>
                      </div>
                      <div>Plant</div>
                      {email === "demokit2@groundup.ai" ? (
                        <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                          Groundup Facility
                        </span>
                      ) : (
                        <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                          {printLocation(
                            alarm?.deployment?.machine_element?.machine
                              ?.location?.parent_location?.location_name
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                  <hr style={{ margin: "0.5rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div className="me-2">
                        <i className="fa fa-warehouse fa-lg fa-fw text-inverse text-opacity-50"></i>
                      </div>
                      <div>Zone</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {printLocation(
                          alarm?.deployment?.machine_element?.machine?.location
                            ?.location_name
                        )}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.5rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div className="me-2">
                        <i className="fa fa-hard-drive fa-lg fa-fw text-inverse text-opacity-50"></i>
                      </div>
                      <div>Machine</div>
                      <span
                        className=" text-theme fw-bold fs-12px ms-auto me-2"
                        style={{ textAlign: "right" }}
                      >
                        {
                          alarm?.deployment?.machine_element?.machine
                            ?.machine_name
                        }
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.5rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div className="me-2">
                        <i className="fa fa-gear fa-lg fa-fw text-inverse text-opacity-50"></i>
                      </div>
                      <div>Machine Element</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {
                          alarm?.deployment?.machine_element
                            ?.machine_element_name
                        }
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.5rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div className="me-2">
                        <i className="fa fa-clock fa-lg fa-fw text-inverse text-opacity-50"></i>
                      </div>
                      <div>Alarm Time</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {`${formatDateOnly(alarm?.min_date)} - ${formatDateOnly(
                          alarm?.max_date
                        )}`}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.5rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div className="me-2">
                        <i className="fa fa-clock fa-lg fa-fw text-inverse text-opacity-50"></i>
                      </div>
                      <div>Alarm Status</div>
                      <span
                        className={`badge fw-bold fs-12px ms-auto me-2 ${
                          alarm?.alert_status?.toLowerCase() === "open"
                            ? "status-open"
                            : alarm?.alert_status?.toLowerCase() === "closed"
                            ? "status-close"
                            : alarm?.alert_status?.toLowerCase() === "invalid"
                            ? "status-invalid"
                            : "status-progress"
                        }`}
                      >
                        {alarm?.alert_status}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <Card>
                    <CardBody style={{ padding: "7px" }}>
                      <ImageViewer
                        src={
                          alarm?.deployment?.machine_element?.machine
                            ?.attachments?.filePhoto
                        }
                      />
                    </CardBody>
                    <CardFooter className={"text-center"}>
                      {
                        alarm?.deployment?.machine_element?.machine
                          ?.machine_name
                      }
                    </CardFooter>
                  </Card>
                </div>
              </div>
            </CardBody>
          </Card>
          {alarm && email === "demokit2@groundup.ai" && (
            <AlertResult alarm={alarm} suspected={suspected}></AlertResult>
          )}

          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Vibration Chart
            </CardHeader>
            <CardBody className="card-body pb-2">
              {alarm ? (
                <VibrationChart
                  threshold_id={alarm?.threshold_id}
                  machine={alarm?.deployment?.machine_element?.machine}
                  deployment={alarm?.deployment}
                  feature_name={alarm?.chart_type}
                  min_date={alarm?.min_date}
                  max_date={alarm?.max_date}
                  chart_type={alarm?.chart_type}
                  alert_id={params.alarmId}
                />
              ) : null}
            </CardBody>
          </Card>
          {
            // loop from object other_charts
            alarm?.other_charts?.map((key, index) => {
              const timestamp = key.timestamp;
              return (
                <Card>
                  <CardHeader>
                    {key.name} - {convertTz(key.timestamp)}
                  </CardHeader>
                  <CardBody>
                    <div
                      key={key}
                      style={{
                        mt: 1,
                        borderRadius: 2,
                        p: 1,
                        display: "block",
                      }}
                    >
                      <OtherChart
                        feature_name={key.name}
                        axis={key.axis}
                        machine={alarm?.deployment?.machine_element?.machine}
                        deployment={alarm?.deployment}
                        timestamp={timestamp}
                        alert_id={params.alarmId}
                      />
                    </div>
                  </CardBody>
                </Card>
              );
            })
          }
        </div>
        <div className="col-lg-4">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
              <div className="flex-1">
                <div>Alarm Finding</div>
              </div>
            </CardHeader>
            <CardBody>
              <p>{alarm?.alert_finding}</p>
              <div
                className="border-theme small text-theme text-bold"
                style={{
                  padding: "0 5px",
                  position: "absolute",
                  right: "10px",
                  bottom: "7px",
                }}
              >
                - GINA.AI
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
              <div className="flex-1">
                <div>Suspected Issue</div>
              </div>
            </CardHeader>
            <CardBody>
              <div className="accordion" id="accordionExample">
                {suspected.map((item, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        style={{ padding: "5px" }}
                        data-bs-target={`#collapse${index}`}
                      >
                        {item.name}
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div style={{ fontWeight: "bold" }}>
                          GINA.AI RECOMMENDATIONS:
                        </div>
                        <ul>
                          {item.recommended_action.map((ra, index) => (
                            <li key={index}>{ra}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
              <div className="flex-1">
                <div>Alarm Response</div>
              </div>
            </CardHeader>
            <CardBody>
              <div className="mb-3">
                <label className="form-label">
                  {alarm?.alert_status !== "Open" ? (
                    <div>
                      The Alarm Response has been updated to "
                      <b>{lastAction}</b>"
                    </div>
                  ) : (
                    "Please select the necessary actions required to address the Alarm."
                  )}
                </label>
                <button
                  className="btn btn-outline-theme w-100 dropdown-toggle rounded-0"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  <span className="d-none d-md-inline">
                    {alarm?.alert_status !== "Open" ? "Update" : "Select"}
                  </span>
                  <span className="d-inline d-md-none">
                    <i className="fa fa-credit-card"></i>
                  </span>{" "}
                  &nbsp;
                </button>
                <div className="dropdown-menu " style={{ cursor: "pointer" }}>
                  {lastAction !== "Monitor and Wait" &&
                    lastAction !== "Invalid" &&
                    lastAction !== "Closed" && (
                      <div
                        className="dropdown-item"
                        href="#/"
                        onClick={() => {
                          handleClickRespond("Monitor and Wait");
                        }}
                      >
                        Monitor and Wait
                      </div>
                    )}
                  {lastAction !== "Proceed with Inspection" &&
                    lastAction !== "Invalid" &&
                    lastAction !== "Closed" && (
                      <div
                        className="dropdown-item"
                        href="#/"
                        onClick={() => {
                          handleClickRespond("Proceed with Inspection");
                        }}
                      >
                        Proceed with Inspection
                      </div>
                    )}
                  {lastAction !== "Proceed with Maintenance" &&
                    lastAction !== "Invalid" &&
                    lastAction !== "Closed" && (
                      <div
                        className="dropdown-item"
                        href="#/"
                        onClick={() => {
                          handleClickRespond("Proceed with Maintenance");
                        }}
                      >
                        Proceed with Maintenance
                      </div>
                    )}
                  {lastAction !== "Invalid" && lastAction !== "Closed" && (
                    <div
                      className="dropdown-item btn-outline-theme"
                      href="#/"
                      onClick={() => {
                        handleUpdateAlert("Closed");
                      }}
                    >
                      Complete Review of Alarm
                    </div>
                  )}
                  {(lastAction === "Invalid" || lastAction === "Closed") && (
                    <div
                      className="dropdown-item"
                      href="#/"
                      onClick={() => {
                        handleReOpenModal("Reopen");
                      }}
                    >
                      Re-open Alarm
                    </div>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
          <div className="accordion" id="accordion2">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingChat">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  style={{ padding: "5px" }}
                  data-bs-target="#collapseChat"
                >
                  <img
                    src="/assets/img/ai_face.png"
                    style={{ width: "35px", marginRight: "10px" }}
                    alt=""
                  />
                  Chat with our AI Assistant
                </button>
              </h2>
              <div
                id="collapseChat"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <Card>
                    <CardHeader className="bg-none fw-bold d-flex align-items-center">
                      GINA AI Assistant{" "}
                      <a
                        href="#/"
                        className="ms-auto text-muted text-decoration-none"
                        data-toggle="card-expand"
                      >
                        <i className="fa fa-expand"></i>
                      </a>
                    </CardHeader>
                    <CardBody className="bg-inverse bg-opacity-10 p-0">
                      <PerfectScrollbar className="h-200px p-3">
                        <div className="widget-chat">
                          <div className="widget-chat-item">
                            <div className="widget-chat-media">
                              <img src="/assets/img/ai_face.png" alt="" />
                            </div>
                            <div className="widget-chat-content">
                              <div className="widget-chat-name">GINA</div>
                              <div className="widget-chat-message last">
                                Is there anything I can help you with?.
                              </div>
                            </div>
                          </div>
                          <div className="widget-chat-item reply">
                            <div className="widget-chat-content">
                              <div className="widget-chat-message last">
                                Nothing
                              </div>
                            </div>
                          </div>
                          <div className="widget-chat-date">Today 14:21</div>
                        </div>
                      </PerfectScrollbar>
                    </CardBody>
                    <CardFooter className="bg-none">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Write your question here..."
                        />
                        <button
                          className="btn btn-outline-default"
                          type="button"
                        >
                          <i className="fa fa-paper-plane text-muted"></i>
                        </button>
                      </div>
                    </CardFooter>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <Card className="mb-4 mt-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Alarm Logs
            </CardHeader>
            <CardBody>
              {!loading ? (
                <AlertLog
                  alert_id={params.alarmId}
                  displayAction={displayAction}
                  updateLastLog={updateLastLog}
                />
              ) : null}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PagesProductDetails;
